"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EGraphicsComponentType = void 0;
/**
 * @public
 * May be used as filter mask.
 */
var EGraphicsComponentType;
(function (EGraphicsComponentType) {
    // annoyingly the type goes to `number` if a shift is applied
    EGraphicsComponentType[EGraphicsComponentType["Entity"] = 1] = "Entity";
    EGraphicsComponentType[EGraphicsComponentType["Composite"] = 2] = "Composite";
})(EGraphicsComponentType = exports.EGraphicsComponentType || (exports.EGraphicsComponentType = {}));
//# sourceMappingURL=e-graphics-component-type.js.map